const Items = [
  {
    id: 1,
    mainImage: "https://res.cloudinary.com/dnuhbyvuq/image/upload/v1719234799/kie0hi6eex4alglo59jt.png",
    img: [
      "https://res.cloudinary.com/dnuhbyvuq/image/upload/v1719467645/nttlzqsb604xevield0h.png",
      "https://res.cloudinary.com/dnuhbyvuq/image/upload/v1719467765/eo3qvaataltusdu1ugu8.png",
      "https://res.cloudinary.com/dnuhbyvuq/image/upload/v1719467831/t6y08cni6pyanxwjrawt.png",
      "https://res.cloudinary.com/dnuhbyvuq/image/upload/v1719467891/xddfgcexrvxodymvot82.png",
      "https://res.cloudinary.com/dnuhbyvuq/image/upload/v1719467988/mb6geypyeuyeluvkdcea.png",
      "https://res.cloudinary.com/dnuhbyvuq/image/upload/v1719468060/q6akjorgjpfs1rfp3tod.png",
      "https://res.cloudinary.com/dnuhbyvuq/image/upload/v1719468134/rtdmve3vmg6givyhxjhw.png",
    ],
    features: [
      "Home",
      "Explore",
      "Create",
      "Saved Pins",
      "User registration and login",
      "Authentication using JWT Tokens",
      "Image searching",
      "Upload user ımages to the server",
      "Liking Images",
      "Commenting on the images",
      "Responsive Design",
    ],
    technologies: [
      "React",
      "Nodejs",
      "MongoDb",
      "Expressjs",
      "Material-UI",
      "Axios",
      "Emoji-Picker-React",
      "Bcryptjs",
      "Cors",
      "Dotenv",
      "Json web token",
      "Nodemon"
    ],
    title: "Pinterest Clone",
    description:
      "Dive into my latest project, a Pinterest clone powered by the MERN stack. From creating captivating pins to seamless user authentication, this project encapsulates my commitment to crafting immersive and user-centric web experiences.",
    category: "personal",
    clientLink: "https://github.com/Chintha2525/Pinterest_Clone_Frontend",
    liveLink: "https://pinterest-clone-2525.netlify.app",
    serverLink: "https://github.com/Chintha2525/Pinterest_Clone_Backend",
    backend: "yes",
  },
  {
    id: 2,
    mainImage: "https://res.cloudinary.com/dnuhbyvuq/image/upload/v1719493030/rvsmhnskquijxlbdad90.png",
    img: [
      "https://res.cloudinary.com/dnuhbyvuq/image/upload/v1719493030/rvsmhnskquijxlbdad90.png",
      "https://res.cloudinary.com/dnuhbyvuq/image/upload/v1719493127/gkczvnd3reouqocv8npc.png",
      "https://res.cloudinary.com/dnuhbyvuq/image/upload/v1719493216/vdbegsegwgohawtnmhc5.png",
      "https://res.cloudinary.com/dnuhbyvuq/image/upload/v1719493288/wnxsqqeehixpdplp1vb6.png",
      "https://res.cloudinary.com/dnuhbyvuq/image/upload/v1719493343/xsuu0rfi1tzcd3aw8nlg.png",
      "https://res.cloudinary.com/dnuhbyvuq/image/upload/v1719493584/calzoftaib4fqssc92sn.png",
      "https://res.cloudinary.com/dnuhbyvuq/image/upload/v1719493653/f5arrf88jef6asub7crn.png",
    ],
    features: [
      "Admin login",
      "CRUD operations (Product create, read, update and delete)",
      "Upload product images",
      "Test mode of RezorPay",
      "Responsive Design",
      "Add to cart page",
      "Contact page and more",
    ],
    technologies: [
      "React",
      "Axios",
      "Bootstrap",
      "Formik",
      "CSS",
      "NodeJS",
      "ExpressJS",
      "MongoDB",
      "Mongoose",
      "Bcryptjs",
      "Emailjs",
      "Dotenv",
      "Nodemon",
      "Json web token",
      "Cors",
    ],
    title: "Rental Portal",
    description:
      "Rental portal include from cars to cameras, offer a diverse array of items for user convenience. Navigate seamlessly through Home, Product, and Cart Items pages, ensuring a user-friendly experience.",
    category: "business",
    clientLink: "https://github.com/Chintha2525/Rental_Portal_Webcode2_FrontEnd",
    liveLink: "https://equipment-rental-portal-2525.netlify.app",
    serverLink: "https://github.com/Chintha2525/Rental_Portal_Webcode2_BackEnd",
    backend: "yes",
  },
  {
    id: 3,
    mainImage: "https://res.cloudinary.com/dnuhbyvuq/image/upload/v1719478810/ufxowwesvkmhvugt7nox.png",
    img: [
      "https://res.cloudinary.com/dnuhbyvuq/image/upload/v1719478810/ufxowwesvkmhvugt7nox.png",
      "https://res.cloudinary.com/dnuhbyvuq/image/upload/v1719479097/ksbqj6lt0hh8xlekhhk4.png",
      "https://res.cloudinary.com/dnuhbyvuq/image/upload/v1719479183/v0ynhu22n3v3ujw945ce.png",
      "https://res.cloudinary.com/dnuhbyvuq/image/upload/v1719479237/jn6pwrpshkeyx5lofjmc.png",
      "https://res.cloudinary.com/dnuhbyvuq/image/upload/v1719479293/umjuyuh6uescozd31oar.png",
    ],
    features: [
      "real-time communication",
      "personalized room IDs",
      "quick messages",
      "instant connections",
      "Responsive Design",
    ],
    technologies: [
      "React",
      "Bootstrap",
      "React-scroll-to-bottom",
      "Socket.io-client",
      "Cors",
      "Express",
      "Dotenv",
    ],
    title: "Chat Application",
    description:
      "Enter the world of real-time communication with my Simple Chat App.",
    category: "personal",
    clientLink: "https://github.com/Chintha2525/Chat-App-Frontend",
    liveLink: "https://chat-app-2525.netlify.app",
    serverLink: "https://github.com/Chintha2525/Chat-App-Backend",
    backend: "yes",
  },
  {
    id: 4,
    mainImage: "https://res.cloudinary.com/dnuhbyvuq/image/upload/v1719487315/ihfiwr66kobe5fkj1imv.png",
    img: [
      "https://res.cloudinary.com/dnuhbyvuq/image/upload/v1719487315/ihfiwr66kobe5fkj1imv.png",
      "https://res.cloudinary.com/dnuhbyvuq/image/upload/v1719487835/zdt6n24gfclofz8rsus8.png",
      "https://res.cloudinary.com/dnuhbyvuq/image/upload/v1719487942/hill4nanaxgmewqsylhp.png",
      "https://res.cloudinary.com/dnuhbyvuq/image/upload/v1719488018/rpbznkfbglkfypxiqgqy.png",
      "https://res.cloudinary.com/dnuhbyvuq/image/upload/v1719488097/knsuhfy6xisjqk4yafyr.png",
    ],
    features: [
      "Simple interface",
      "Funny sound effects",
      "The game is to be played between two people",
      "No time limit",
      "Responsive Design",
    ],
    technologies: [
      "HTML",
      "CSS",
      "Javascript",
      "Audio Effects",
      "Dom",
    ],
    title: "Tic Tac Toe",
    description:
      "This is a simple web-based game that allows two players to compete against each other. This classic brings strategic twists and turns to user fingertips.",
    category: "game",
    clientLink: "https://github.com/Chintha2525/Tic-Tac-Toe",
    liveLink: "https://tic-tac-toe-2525.netlify.app",
    backend: "no",
  },
  {
    id: 5,
    mainImage: "https://res.cloudinary.com/dnuhbyvuq/image/upload/v1719901109/rwevos3vhyiopcsjeiud.png",
    img: [
      "https://res.cloudinary.com/dnuhbyvuq/image/upload/v1719901171/bdf0mblnxmjjfleaykhz.png",
      "https://res.cloudinary.com/dnuhbyvuq/image/upload/v1719901208/crxyercgbsggzctu3ezz.png",
      "https://res.cloudinary.com/dnuhbyvuq/image/upload/v1719901250/qxnljzckxki8v6jvrskw.png",
      "https://res.cloudinary.com/dnuhbyvuq/image/upload/v1719901287/xy1fvoxcjhhu5gfsf4rh.png",
      "https://res.cloudinary.com/dnuhbyvuq/image/upload/v1719901327/xmcnb5neozqzgbptrnnp.png",
    ],
    features: [
      "Add Student",
      "Edit Student",
      "Remove Student",
      "No Student Page",
      "Responsive Design",
      "404 Page and many more",
    ],
    technologies: [
      "React",
      "React Hooks",
      "React Router Dom",
      "Axios",
      "Bootstrap",
      "React Icons",
      "Sweet Alert2",
      "Node JS",
      "Express JS",
      "Cors",
      "Mongoose",
      "Dotenv",
      "Nodemon",
      "MongoDB",
    ],
    title: "Student Management System",
    description:
      "Fullstack open source student management system application made with MongoDB, Express, React & Nodejs (MERN)",
    category: "business",
    clientLink: "https://github.com/Chintha2525/student-management-frontend",
    liveLink: "https://student-management-2525.netlify.app",
    serverLink: "https://github.com/Chintha2525/student-management-backend",
    backend: "yes",
  },
];

export default Items;
